import { useEffect } from "react";
import DashboardReusable from "../UI/DashboardReusable";
import RequisitionContainer from "./RequisitionContainer";
import { useState } from "react";
import { getRequisitions } from "../../util/http";
import { useContext } from "react";
import { AuthContext } from "../../util/context";

export default function Requisition() {
  const [list, setList] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const lastIndex = currentPage * perPage;
  const firstIndex = lastIndex - perPage;

  const { user } = useContext(AuthContext);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const response = await getRequisitions();
        setLoading(false);
        if (
          user.job_role?.toLowerCase() === "lawyer" ||
          user?.job_role?.toLowerCase() === "hr"
        ) {
          setList(
            response?.requisitions
              ?.filter(
                (el) =>
                  +el.initiator?.initiator_id === +user?.id &&
                  el?.deleted_at === null
              )
              .reverse()
          );
        } else if (
          user?.job_role?.toLowerCase().includes("hod") ||
          user?.job_role?.toLowerCase() === "hop"
        ) {
          setList(
            response?.requisitions
              ?.filter(
                (el) =>
                  el.brief_type?.toLowerCase() ===
                    user?.department?.toLowerCase() && el?.deleted_at === null
              )
              .reverse()
          );
        } else {
          setList(
            response?.requisitions
              ?.filter((el) => el?.deleted_at === null)
              .reverse()
          );
        }
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    }
    fetchData();
  }, [user?.department, user?.id, user?.job_role]);

  useEffect(() => {
    setTotal(list.length);
  }, [list]);

  const requisitionList = list.slice(firstIndex, lastIndex);

  return (
    <DashboardReusable>
      <RequisitionContainer
        list={requisitionList}
        total={total}
        perPage={perPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setList={setList}
        loading={loading}
      />
    </DashboardReusable>
  );
}
